"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsPromise = void 0;
function assertIsPromise(input, message) {
    if (!(input instanceof Promise)) {
        // We don't throw Node's AssertionError because the code size will be larger.
        throw new TypeError(message);
    }
}
exports.assertIsPromise = assertIsPromise;
